import { apiClient } from '@repo/shared';

const initialiseNewStudent = () => {
  return {
    id: "",
    firstName: "",
    lastName: "",
    school: {id: 0},
    year: "",
    parentName: "",
    address: "",
    emailAddress: "",
    phoneNumber: "",
    class: {},
    createdAt: "",
    updatedAt: "",
    notes: "",
    enrolments: [],
  };
}

const getAll = async () => {
  const students = await apiClient.get("/api/students");
  return students;
};

const getByEnrolmentYear = async (enrolmentYear) => {
  const students = await apiClient.get(`/api/students?enrolmentYear=${enrolmentYear}`);
  return students;
};

const get = async (id) => {
  const student = await apiClient.get(`/api/students/${id}`);
  return student?.[0];
};

const getAllForClass = async classId => {
  const students = await apiClient.get(`/api/students?classId=${classId}`);
  return students;
};

const getAllForEvent = async eventId => {
  const students = await apiClient.get(`/api/students?eventId=${eventId}`);
  return students;
};

const getAllStudentsForSchoolAndYear = async (schoolId, schoolYear) => {
  const students = await apiClient.get(`/api/students?schoolId=${schoolId}&schoolYear=${schoolYear}`);
  return students;
};

const getStudentsForParent = async (parentId) => {
  const students = await apiClient.get(`/api/parents/${parentId}/students`);
  return students;
};

const create = async (student) => {
  student.schoolId = student.school.id;
  student.verified = student.verified ? student.verified : false;
  student.welcomeEmailSent = student.welcomeEmailSent ? student.welcomeEmailSent : false;
  return await apiClient.post(`/api/students`, student);
};

const update = async (id, student) => {
  student.schoolId = student.school.id;
  student.verified = student.verified ? student.verified : false;
  student.welcomeEmailSent = student.welcomeEmailSent ? student.welcomeEmailSent : false;
  return await apiClient.post(`/api/students/${id}`, student);
};

const remove = async (id) => {
  //return http.delete(`/klassen/${id}`);
  const students = await apiClient.delete(`/api/students/${id}`);
  return students;
};

const StudentService = {
  getAll,
  getByEnrolmentYear,
  getAllForClass,
  getAllForEvent,
  getAllStudentsForSchoolAndYear,
  get,
  create,
  update,
  remove,
  initialiseNewStudent,
  getStudentsForParent,
};

export default StudentService;